import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import { ArrowLeftIcon } from '../../Icons/ArrowIcons'


interface BackButtonProps {
  title: string
  className?: string
  handleBack: () => void
}

const BackButton = ({ title, className, handleBack }: BackButtonProps): JSX.Element => {
  const locale = useSelector((state: RootState) => state.localeReducer.locale)

  return (
    <button className={`rf-flex rf-flex-row rf-items-center ${className}`} onClick={handleBack} aria-label={title} data-map='fermer'>
      <ArrowLeftIcon className='rf-w-8' />
      <div className='rf-ml-1'>{capitalizeFirstLetter(title, locale)}</div>
    </button>
  )
}

export default BackButton
